export default __webpack_public_path__ + "static/media/2.f714b557.png";